import React from 'react';
import { MAIN_CONFIG } from '../../../config/main';


export default ({ id, className, color = MAIN_CONFIG.COLORS.fillBlue, width = "24px", height = "24px", ariaLabel = "Plus", ariaLabelDescription = "Plus" }) => {
    return (
        <svg id={id} className={className} xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 16 16">
            <title>{ariaLabel}</title>
            <desc>{ariaLabelDescription}</desc>
            <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z" fill={color} />
        </svg>
    );
}
